import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <table className="ilead_v_sport people_active" border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve green_curve1" align="left"
                                                        valign="top" width="50%">My Core Values
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="50%">
                                                        <textarea rows="5"
                                                                  cols="100"
                                                                  style={{width: '100%', height: '269px'}}
                                                                  name="MyCoreValues"
                                                                  id="MyCoreValues"
                                                                  value={this.props.pageData?.MyCoreValues}
                                                                  onChange={this.props.handleChangeTextarea}/>
                                                        <br/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <div className="border_subtitle">Step 2 – Identify your
                                                preferences
                                            </div>
                                            <div className="paraspace "><p>Having noted your core values,
                                                another major influence on your behaviour will be your
                                                personality or behaviour ‘preferences’. You may already know
                                                what these are, or have completed a test to establish them, such
                                                as the Myers Briggs Type Indicator.<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>4</sup></a> However
                                                it’s still useful to summarise your preferences before
                                                completing ‘Step 3’. Typical preferences can include being
                                                optimistic, trusting others and being busy with a variety of
                                                things to do. Answering the following questions will help you
                                                with this:</p></div>
                                            <ul className="greenbullet-list">

                                                <li>What do you particularly enjoy?</li>
                                                <li>What motivates you?</li>
                                                <li>What makes you particularly happy?</li>
                                                <li>What are your particular strengths in the way you relate to
                                                    others?
                                                </li>
                                                <li className="list-bottom-pad">What do you most enjoy doing at
                                                    work?
                                                </li>


                                            </ul>
                                            <p></p>
                                            <table className="ilead_v_sport people_active" border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve green_curve1" align="left"
                                                        valign="top" width="50%">My Preferences
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="50%">
                                                                <textarea rows="5"
                                                                          cols="100"
                                                                          style={{width: '100%', height: '269px'}}
                                                                          name="MyPreferences"
                                                                          id="MyPreferences"
                                                                          value={this.props.pageData?.MyPreferences}
                                                                          onChange={this.props.handleChangeTextarea}/>
                                                        <br/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page5')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}